import { useQuery } from "react-query";
import { getDataConnectionList } from "../../../../../actions/Utilities/DataConnection";

export default function useGetDataConnectionList () {
  return useQuery("GetDataConnection",getDataConnectionList, {
    refetchOnWindowFocus: false,
  });
}
